import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { DEFAULT_PILLOW_VARIANT, deletePillow, fetchPillow, regeneratePillow } from "../../api/pillows";
import { useResource } from "../../lib/useResource";
import DetailPage from "../../components/detail/DetailPage";
import AddVariantForm from "../../components/generate/AddVariantForm";
import PillowVariantFields from "../../components/generate/PillowVariantFields";
import { pillowPresenter } from "../../components/models/presenters";
import { ErrorState, LoadingState, Page } from "../../components/ui";

export default function PillowView({ id }: { id: string }) {
  const { instance } = useMsal();
  const { data, error, loading, setData } = useResource(id, fetchPillow);
  const [variant, setVariant] = useState(DEFAULT_PILLOW_VARIANT);

  if (loading || data === null) {
    return error ? <Page title="Pillow"><ErrorState message={error} /></Page> : <LoadingState h={400} />;
  }

  return (
    <DetailPage
      title="Pillow"
      galleryPath="/gallery/pillows"
      data={data}
      presenter={pillowPresenter}
      shading="matte"
      addVariant={
        <AddVariantForm title="Generate another colour" onGenerate={async () => setData(await regeneratePillow(instance, id, variant))}>
          <PillowVariantFields value={variant} onChange={setVariant} />
        </AddVariantForm>
      }
      onRegenerateModel={(model) => regeneratePillow(instance, id, { color: model.color, removalMode: variant.removalMode })}
      onDataChange={setData}
      onDelete={() => deletePillow(instance, id)}
    />
  );
}
